define([
    "dojo/_base/declare",
    "csi/form/Widget",
    "csi/store/Locales"
], function(declare,Widget,Locales) {

	return declare(Widget, {
		localeFieldName: "Locale",

		getFieldStore: function(/*Field*/field, /*String*/value) {
			if (field.m_name == this.localeFieldName || field.m_id == this.localeFieldName ) {
			    return Locales;
			}

			return this.inherited(arguments);
		}
	});
});